export const LAME_HEADS_SCORE_OPTIONS = [
	{ type: 1, value: '1 балл' },
	{ type: 2, value: '2 балла' },
	{ type: 3, value: '3 балла' },
	{ type: 4, value: '4 балла' },
	{ type: 5, value: '5 баллов' },
]

export const LAME_HEADS_ALL_SCORE_VALUES = LAME_HEADS_SCORE_OPTIONS.map(
	option => option.type,
)
